import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
import styled from "styled-components"
import GatsbyImage from "../common/gatsby-image"
import { register } from "swiper/element/bundle"

register()

const StyledGallery = styled.div`
  width: 100%;

  @media (min-width: 769px) {
    max-width: 62.5rem;
  }

  .swiper-slide {
    display: flex;
  }

  .main-slider {
    position: relative;
    height: 24rem;

    @media (min-width: 769px) {
      height: 44rem;
    }

    .gatsby-image-wrapper {
      max-height: 100%;
    }
    img {
      object-fit: contain !important;
    }
  }

  .thumbnail-swiper {
    margin-top: 2rem;
    max-height: 6rem;
    height: 100%;
    padding-bottom: 0.2rem;

    @media (min-width: 769px) {
      max-height: 15.2rem;
    }

    .swiper-slide {
      box-sizing: border-box;
      height: 5.8rem;
      border: 0.1rem solid rgb(207, 207, 207);

      @media (min-width: 769px) {
        height: 100%;
      }

      &:hover {
        border-color: rgb(149, 149, 149);
      }

      .gatsby-image-wrapper {
        max-height: 100%;
      }

      img {
        object-fit: contain !important;
      }
    }
  }
`

const SlideInner = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

const StyledThumbnailInnerLabel = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  position: absolute;
  top: 0;
  left: 0;
  bottom: -0.1rem;
  width: 100%;
  font-family: museo_sans500;
  font-size: 1.8rem;
  background: rgba(0, 0, 0, 0.7);
  margin: 0;
  padding: 0 1rem;
  opacity: 0;
  transition: all 300ms linear;
  box-sizing: border-box;

  &:hover {
    color: #fff;
    opacity: 1;
  }

  span {
    white-space: normal;
    line-height: 2rem;
  }
`

const ProductGallery = ({ images = [] }) => {
  const mainSwiper = useRef(null)
  const thumbsSwiper = useRef(null)
  const thumbClick = index => {
    thumbsSwiper.current.swiper.slideTo(index)
    mainSwiper.current.swiper.slideTo(index)
  }

  useEffect(() => {
    const params = {
      injectStyles: [
        `
        .swiper-button-disabled {
          display: none;
        }
    
        .swiper-button-next,
        .swiper-button-prev {
          z-index: 9;
          background-color: #fff;
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 50%;
      
          &:after {
            font-size: 1.5rem;
            font-weight: bold;
          }
      
          @media (min-width: 769px) {
            width: 4rem;
            height: 4rem;
      
            &:after {
              font-size: 2.5rem;
            }
          }

          &:hover {
            path{
              fill:rgb(181, 22, 27);
            }
          }
          
          svg{
            height: 3rem;
            
            path{
              fill: rgb(149, 149, 149);
              transition: 200ms linear;
            }
          }
        }

      `,
      ],
    }

    // Assign it to swiper element
    Object.assign(mainSwiper.current, params)
    Object.assign(thumbsSwiper.current, {
      ...params,
      breakpoints: {
        200: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
    })

    // initialize swiper
    mainSwiper.current.initialize()
    thumbsSwiper.current.initialize()
  }, [])

  if (!images) return null

  return (
    <StyledGallery>
      <swiper-container
        class="main-slider"
        navigation="true"
        init="false"
        ref={mainSwiper}
        data-testid="image-gallery"
      >
        {images.map(item => (
          <swiper-slide
            className="swiper-slide"
            data-testid="gallery-item"
            key={item.contentful_id}
          >
            <GatsbyImage image={item.gatsbyImageData} alt="" />
          </swiper-slide>
        ))}
      </swiper-container>
      <swiper-container
        ref={thumbsSwiper}
        class="thumbnail-swiper"
        navigation={"true"}
        slides-per-view={3}
        space-between={10}
        init="false"
      >
        {images.map((item, index) => (
          <swiper-slide key={item.contentful_id} class="swiper-slide">
            <SlideInner
              onClick={() => {
                thumbClick(index)
              }}
            >
              <GatsbyImage image={item.gatsbyImageData} alt="" />
              <StyledThumbnailInnerLabel>
                <span>{item.thumbnailLabel}</span>
              </StyledThumbnailInnerLabel>
            </SlideInner>
          </swiper-slide>
        ))}
      </swiper-container>
    </StyledGallery>
  )
}

ProductGallery.propTypes = {
  images: PropTypes.array,
  speed: PropTypes.number,
}

export default ProductGallery
